import { render } from "./DrawSVGPluginNr1.vue?vue&type=template&id=7175db02&scoped=true"
import script from "./DrawSVGPluginNr1.vue?vue&type=script&lang=js"
export * from "./DrawSVGPluginNr1.vue?vue&type=script&lang=js"

import "./DrawSVGPluginNr1.vue?vue&type=style&index=0&id=7175db02&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7175db02"]])

export default __exports__